import { Rating, Grid, Typography, Card } from '@mui/material';

export const BookingRating = props => {
    return (
        <Card sx={{ marginTop: '24px', padding: '20px', width: '100%' }}>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h5" color="secondary">
                        Booking Rating:
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Rating
                        name="simple-controlled"
                        value={props.rating}
                        size="large"
                        precision={0.5}
                        disabled
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body1">{props.comments}</Typography>
                </Grid>
            </Grid>
        </Card>
    );
};

export default BookingRating;
